module.exports = __webpack_public_path__ + "img/link-externo3.27858862.svg";